/** Événement `window` qui ouvre la palette (boutons de la coquille ou de la carte). */
export const EVENEMENT_OUVRIR_PALETTE = 'palette:ouvrir';

export function ouvrirPalette(): void {
  window.dispatchEvent(new Event(EVENEMENT_OUVRIR_PALETTE));
}
